import { render, staticRenderFns } from "./gather.vue?vue&type=template&id=6e79549e&scoped=true&"
import script from "./gather.vue?vue&type=script&lang=js&"
export * from "./gather.vue?vue&type=script&lang=js&"
import style0 from "./gather.vue?vue&type=style&index=0&id=6e79549e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79549e",
  null
  
)

export default component.exports